import { Link } from 'react-router-dom';
import LegalPage, { LEGAL_CONTACT, LegalSection } from './LegalPage';

const mail = <a href={`mailto:${LEGAL_CONTACT}`}>{LEGAL_CONTACT}</a>;

const sections: LegalSection[] = [
  { id: 'applies', heading: 'Who this agreement applies to', body: <>
    <p>This End User Agreement applies when you use the FluxWatch vendor portal to answer a security questionnaire or
      respond to a remediation request on behalf of your organisation, at the invitation of one of your customers
      ("Requesting Customer"). By creating a portal account or submitting a response, you confirm you are authorised to
      respond for your organisation and you accept this agreement.</p>
  </> },
  { id: 'responses', heading: 'Your responses', body: <>
    <p>Answer questions and provide evidence truthfully and to the best of your knowledge. The Requesting Customer that
      sent the questionnaire or request receives your answers and uses them in its own assessment of your organisation.
      Once submitted, a response may be reviewed and sent back to you for clarification.</p>
  </> },
  { id: 'account', heading: 'Your account', body: <>
    <p>Your portal account is identified by your work email and can be used for questionnaires and remediation requests
      from more than one customer. Each customer sees only what was sent by or to them, never another customer's
      requests. Keep your sign-in details secure, and tell us at {mail} if you think someone else has accessed your account.</p>
    <p>You can invite colleagues to help answer a questionnaire. You are responsible for inviting only people from your
      organisation who should see it.</p>
  </> },
  { id: 'evidence', heading: 'Evidence you upload', body: <>
    <p>Documents you upload, such as policies, certificates and audit reports, are shared only with the Requesting Customer
      of the questionnaire or request they are attached to. They may be analysed to suggest answers or to check that an
      answer is supported. Upload only documents you are permitted to share, and remove or redact anything the customer
      does not need.</p>
  </> },
  { id: 'rating', heading: 'Your security rating', body: <>
    <p>The portal may show a security rating for your organisation, based on publicly observable information about your
      company's domain. It is provided for your information, it is calculated separately from any customer's own
      assessment, and it is not shared with customers through the portal. Your organisation's administrators can choose
      to create their own FluxWatch workspace to see the full results.</p>
  </> },
  { id: 'ownership', heading: 'Ownership and confidentiality', body: <>
    <p>Your organisation keeps ownership of the information and documents it provides. The Requesting Customer may use
      them to assess and manage its relationship with your organisation, under whatever agreement exists between you.
      FluxVell processes them only to operate the portal and the customer's FluxWatch workspace, as described in our{' '}
      <Link to="/privacy">Privacy Policy</Link>.</p>
  </> },
  { id: 'use', heading: 'Acceptable use', body: <>
    <p>Do not use the portal to upload malware, try to access requests or data not addressed to you, interfere with the
      service, or submit content you know to be false or misleading.</p>
  </> },
  { id: 'changes', heading: 'Changes', body: <>
    <p>We may update this agreement. The current version and date are always shown on this page, and you may be asked to
      accept a new version before your next response.</p>
  </> },
  { id: 'contact', heading: 'Contact', body: <>
    <p>Questions about this agreement or the vendor portal: {mail}. For questions about a specific questionnaire, contact
      the customer that sent it.</p>
  </> },
];

export default function VendorPortalTerms() {
  return (
    <LegalPage title="Vendor Portal End User Agreement" sections={sections}
      backTo="/questionnaire/portal" backLabel="← Back to vendor portal"
      intro={<p>This agreement explains how the FluxWatch vendor portal works when a customer asks your organisation to complete a
        security questionnaire or a remediation request.</p>} />
  );
}
